import { APP_MODE_TYPES, appMode } from 'src/config'
import { CONDITIONS, CONDITIONS_REQUIREMENTS, TYPES } from 'src/models/booking-fee-type/BookingFeeType'

/**
 * Computes the highest priority applicable BookingFeeType for a Item OrderItem.
 */
class BookingFeesItemComputer {
  static #instance = null

  constructor () {
    if (!BookingFeesItemComputer.#instance) {
      BookingFeesItemComputer.#instance = this
    }
    return BookingFeesItemComputer.#instance
  }

  /**
   * Compute the highest priority BookingFeeType for the given Item OrderItem,
   * based on the OrderItem's state and any conditions configured for each BookingFeeType.
   * @param {OrderItem} orderItem
   * @returns {BookingFeeType} validBookingFeeType
   */
  compute (orderItem) {
    const bookingFeeTypes = _.sortBy(orderItem.configuration?.bookingFeeTypes?.data, 'priorityOrder')

    const validBookingFeeType = _.find(bookingFeeTypes, bookingFeeType => {
      if (bookingFeeType.type !== TYPES.ITEM) return false
      if (!bookingFeeType.isActive) return false

      const channel = this.#channel(orderItem)
      if (!bookingFeeType.channels[channel]) return false

      if (bookingFeeType.conditions[CONDITIONS.PRICE]) {
        const price = orderItem.setAsGross
          ? orderItem.total - orderItem.bookingFeeTotal
          : orderItem.subtotal - orderItem.bookingFeeAmount

        const atLeastMinPrice = price >= bookingFeeType.conditionsRequirements[CONDITIONS_REQUIREMENTS.MIN_PRICE]
        const atMostMaxPrice = _.isNil(bookingFeeType.conditionsRequirements[CONDITIONS_REQUIREMENTS.MAX_PRICE]) ||
                              price <= bookingFeeType.conditionsRequirements[CONDITIONS_REQUIREMENTS.MAX_PRICE]
        const includesPrice = atLeastMinPrice && atMostMaxPrice

        if (bookingFeeType.conditionsRequirements[CONDITIONS_REQUIREMENTS.EXCLUDE_PRICE] === includesPrice) return false
      }

      if (bookingFeeType.conditions[CONDITIONS.DELIVERY_LOCATIONS]) {
        const orderDeliveryLocationId = orderItem.effectiveDeliveryLocationModel?.id

        if (bookingFeeType.conditionsRequirements[CONDITIONS_REQUIREMENTS.EXCLUDE_DELIVERY_LOCATIONS] === _.includes(bookingFeeType.deliveryLocationIds, orderDeliveryLocationId)) return false
      }

      return true
    })

    return validBookingFeeType
  }

  // private

  /**
   * Gets the appropriate channel for the given OrderItem.
   * The channel is determined by the being application used to place the given OrderItem.
   * @param {OrderItem} orderItem
   * @returns {String} channel
   */
  #channel (orderItem) {
    let channel

    switch (appMode) {
      case APP_MODE_TYPES.REGISTER:
        channel = orderItem?.order?.phoneOrder ? 'phone' : 'register'
        break
      case APP_MODE_TYPES.CONSUMER:
        channel = 'website'
        break
      default:
        channel = appMode
    }

    return channel
  }
}

const itemBookingFeeComputer = new BookingFeesItemComputer()
export default itemBookingFeeComputer
